import { z } from 'zod';
import extend from './extend.js';

export enum ProjectStatus {
  Inactive = 1,
  Active = 2,
  Archived = 3,
  Draft = 4,
}

export enum ProjectType {
  Survey = 1,
  Call = 2,
  SurveyCall = 3,
}

export const ProjectTypeSchema = z.enum(ProjectType);

export const ProjectTypeMap = extend(
  new Map([
    [ProjectType.Call, { name: 'Interviews' }],
    [ProjectType.Survey, { name: 'Online Survey' }],
    [ProjectType.SurveyCall, { name: 'Screener + Interviews' }],
  ])
);

export enum ProjectSubtype {
  OpportunityAssessment = 1,
  ConceptTesting = 2,
  MessageTesting = 3,
  PositioningTesting = 4,
  VisualAidTesting = 5,
  PatientJourney = 6,
  JourneyTesting = 7,
  Other = 8,
  Segmentation = 9,
  DriversAndBarriers = 10,
  DemandAssessment = 11,
  CurrentLandscape = 12,
  /* AdverseEventsManagement = 13, */
  USTPPPAndMAOpportunityAssessment = 13,
  EXUSTPPPAndMAOpportunityAssessment = 14,
  FinalLaunchPricingUS = 15,
  FinalLaunchPricingEU = 16,
  ValueMessageDevelopmentWithTesting = 17,
}
export const ProjectSubtypeSchema = z.enum(ProjectSubtype);

export const ProjectSubtypeNameMap: Map<ProjectSubtype, string> = new Map([
  [ProjectSubtype.OpportunityAssessment, 'Opportunity Assessment'],
  [ProjectSubtype.ConceptTesting, 'Concept Testing'],
  [ProjectSubtype.MessageTesting, 'Message Testing'],
  [ProjectSubtype.PositioningTesting, 'Positioning Testing'],
  [ProjectSubtype.VisualAidTesting, 'Visual Aid Testing'],
  [ProjectSubtype.PatientJourney, 'Patient Journey'],
  [ProjectSubtype.JourneyTesting, 'Journey Testing'],
  [ProjectSubtype.Other, 'Other'],
  [ProjectSubtype.Segmentation, 'Segmentation'],
  [ProjectSubtype.DriversAndBarriers, 'Drivers and Barriers Analysis'],
  [ProjectSubtype.DemandAssessment, 'Demand Assessment'],
  [ProjectSubtype.CurrentLandscape, 'Current Landscape Analysis'],
  /* [ProjectSubtype.AdverseEventsManagement, 'Adverse Events Management'], */
  [ProjectSubtype.USTPPPAndMAOpportunityAssessment, 'US - TPP P&MA Opportunity Assessment'],
  [ProjectSubtype.EXUSTPPPAndMAOpportunityAssessment, 'EX-US - TPP P&MA Opportunity Assessment'],
  [ProjectSubtype.FinalLaunchPricingUS, 'Final Launch Pricing (US)'],
  [ProjectSubtype.FinalLaunchPricingEU, 'Final Launch Pricing (EU)'],
  [ProjectSubtype.ValueMessageDevelopmentWithTesting, 'Value Message Development (With Testing)'],
]);

export enum AudienceType {
  Payer = 1,
  Patient = 2,
  HealthcareProfessional = 3,
  HealthcarePractitioner = 4,
  Other = 5,
}

export enum ProjectGoalType {
  Call = 1,
  Survey = 2,
}

export * from './project.action.js';
export * from './project.user.js';
